export default "__VITE_ASSET__rDkdIs7H__"